module.exports = __webpack_public_path__ + "static/media/IlotB_synthese_4.039fc077.webp";